import { NgForm } from '@angular/forms';

export class FormUtil {
  static isValid(form: NgForm): boolean {
    if (form.valid) {
      return true;
    } else {
      Object.keys(form.controls).forEach(key => form.controls[key].markAsTouched());
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/form.util.ts